<div class="two-column-layout">
    <app-tile
            [tabindex]="1"
            [title]="'GENERAL.GERMAN' | translate"
            [text]="'ONBOARDING.LANGUAGE_OPTION.DESCRIPTION_DE' | translate"
            (tileClickEvent)="nextStepClick(german)">
        <div language-option class="language">
            <span class="language__indicator">DE</span>
        </div>
    </app-tile>
    <app-tile
            [tabindex]="2"
            [title]="'GENERAL.ENGLISH' | translate"
            [text]="'ONBOARDING.LANGUAGE_OPTION.DESCRIPTION_EN' | translate"
            (tileClickEvent)="nextStepClick(englishGB)">
        <div language-option class="language">
            <span class="language__indicator">EN</span>
        </div>
    </app-tile>
</div>
